import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { IOrganisation, defaultValue } from 'app/shared/model/organisation.model';
import { IQueryParams, serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState = {
  loading: false,
  errorMessage: null,
  organisations: [] as ReadonlyArray<IOrganisation>,
  authorities: [] as any[],
  currentOrganisation: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0,
};
const apiUrl = 'api/organisations';

export const getOrganisations = createAsyncThunk('organisations/fetch_organisations', async () => {
  const requestUrl = `${apiUrl}`;
  return axios.get<IOrganisation[]>(requestUrl);
});

export type OrganisationState = Readonly<typeof initialState>;

export const OrganisationSlice = createSlice({
  name: 'organisation',
  initialState: initialState as OrganisationState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder.addMatcher(isFulfilled(getOrganisations), (state, action) => {
      state.loading = false;
      state.organisations = action.payload.data;
      state.currentOrganisation = action.payload.data[0];
      state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
    });
  },
});

export const { reset } = OrganisationSlice.actions;

// Reducer
export default OrganisationSlice.reducer;
